<template>
  <div class="container">
    <div id="get-sign-in-code"></div>
    <div class="card margin-top">
      <div class="title-register">
      
        <router-link class="navbar-brand" :to="{ name: 'Home' }"><img alt="Secc logo" src="../../../assets/secclogo.png" /></router-link>
        <h3 class="font-moul pt-3" style="font-size:14px; text-align:center;line-height: 30px;">
          ប្រព័ន្ធចុះឈ្មោះ និងការបង់ថ្លៃតាមអនឡាញ សម្រាប់វគ្គបណ្ដុះបណ្ដាលនិងការប្រឡង និងកម្មវិធីអប់រំវិជ្ជាជីវៈបន្តក្នុងវិស័យមូលបត្រ
        </h3>
        <h3 class="font-moul pt-3" style="font-size:14px; text-align:center;">
          {{$t("message.create_account")}} ឬក៏ប្រើប្រាស់គណនី CamDigiKey
        </h3>
        <button
          type="buttom"
          class="btn btn-primary mt-3"
          @click.prevent="getCamDigikey"
        >
          <img src="@/assets/images/unnamed.webp" class="mr-2" style="height:20px;"/> Sign In with CamDigiKey
        </button>
      </div>
      <div class="card-body" ref="formContainer">
        <div class="card">
          <!-- <h5
          class="card-header text-center font-moul"
          style="font-size:14px; text-align:center;"
        >
          បង្កើតគណនី
        </h5> -->
          <div
            class="card-body"
            v-if="showNumberInput"
            style="margin:auto;width:80%;"
          >
            <form v-on:submit.prevent>
              <label class="form-label">{{$t("message.type_of_trainee")}}<span class="text-danger">*</span></label>
              <div class="input-group mb-3">
                <!-- <label class="input-group-text" for="inputGroupSelect01"
                >Gender</label
              > -->
                <select
                  class="form-select"
                  :class="{ 'is-invalid': v$.form.participant_type.$error }"
                  v-model="form.participant_type"
                  @input="updateForm"
                  id="inputGroupSelect01"
                >
                  <option selected>Choose...</option>
                  <option value="1">{{$t("message.individual")}} ({{$t("message.individual")}})</option>
                  <option value="2">{{$t("message.institution")}} ({{$t("message.company")}})</option>
                </select>
              </div>
              <span v-if="form.participant_type == 2">
                <label for="" class="form-label">{{$t("message.company_name")}}<span class="text-danger">*</span></label>
                <div class="input-group mb-3">
                  <!-- <span class="input-group-text">Last and Frist name (khmer)</span> -->
                  <input
                    type="text"
                    v-model.trim="form.company_name"
                    @input="updateForm"
                    aria-label=""
                    class="form-control"
                    :placeholder='$t("message.company_name")'
                    :class="{ 'is-invalid': v$.form.company_name.$error }"
                  />
                </div>
              </span>

              <label for="lastname-firstname" class="form-label"
                >{{$t("message.full_name")}}({{$t("message.in_khmer")}})<span class="text-danger">*</span></label
              >
              <div class="input-group mb-3">
                <!-- <span class="input-group-text">Last and Frist name (khmer)</span> -->
                <div class="col-md-6">
                  <input
                    type="text"
                    v-model.trim="form.lastname"
                    @input="updateForm"
                    aria-label="Last name"
                    class="form-control"
                    :placeholder='$t("message.last_name")'
                    :class="{ 'is-invalid': v$.form.lastname.$error }"
                  />
                  <div class="invalid-feedback" v-if="errors?.lastname">
                    {{errors?.lastname[0]}}
                  </div>
                </div>
                <div class="col-md-6">
                  <input
                    type="text"
                    v-model.trim="form.firstname"
                    @input="updateForm"
                    aria-label="First name"
                    class="form-control"
                    :placeholder='$t("message.first_name")'
                    :class="{ 'is-invalid': v$.form.firstname.$error }"
                  />
                  <div class="invalid-feedback" v-if="errors?.firstname">
                    {{errors?.firstname[0]}}
                  </div>
                </div>
              </div>

              <label for="lastname-firstname-latine" class="form-label"
                >{{$t("message.full_name")}}({{$t("message.in_latin")}})<span class="text-danger">*</span></label
              >
              <div class="input-group mb-3">
                <!-- <span class="input-group-text">Last and Frist name (Latine)</span> -->
                <div class="col-md-6">
                  <input
                    type="text"
                    v-model="form.lastname_en"
                    @input="updateForm"
                    aria-label="Last name"
                    :placeholder='$t("message.last_name")'
                    class="form-control"
                    :class="{ 'is-invalid': v$.form.lastname_en.$error }"
                  />
                  <div class="invalid-feedback" v-if="errors?.lastname_en">
                    {{errors?.lastname_en[0]}}
                  </div>
                </div>
                <div class="col-md-6">
                  <input
                    type="text"
                    v-model="form.firstname_en"
                    @input="updateForm"
                    aria-label="First name"
                    :placeholder='$t("message.first_name")'
                    class="form-control"
                    :class="{ 'is-invalid': v$.form.firstname_en.$error }"
                  />
                  <div class="invalid-feedback" v-if="errors?.firstname_en">
                    {{errors?.firstname_en[0]}}
                  </div>
                </div>
              </div>

              <label for="first-name" class="form-label">{{$t("message.gender")}}<span class="text-danger">*</span></label>
              <div class="input-group mb-3">
                <!-- <label class="input-group-text" for="inputGroupSelect01"
                >Gender</label
              > -->
                <select
                  class="form-select"
                  :class="{ 'is-invalid': v$.form.gender.$error }"
                  v-model="form.gender"
                  @input="updateForm"
                  id="inputGroupSelect01"
                >
                  <option selected>Choose...</option>
                  <option value="1">ប្រុស (Male)</option>
                  <option value="2">ស្រី (Female)</option>
                </select>
              </div>

              <label for="dob" class="form-label">{{$t("message.dob")}}<span class="text-danger">*</span></label>
              <div class="input-group mb-3">
                <!-- <label class="input-group-text" for="dob2">Date Of Birth</label> -->
                <input
                  v-maska="'##/##/####'"
                  v-model="form.dob"
                  @input="updateForm"
                  class="form-control"
                  :class="{ 'is-invalid': v$.form.dob.$error }"
                  id="dob"
                  placeholder="dd/mm/yyyy"
                  aria-label="date_of_birth"
                  aria-describedby="dob2"
                />
              </div>

              <label for="nationality" class="form-label">{{$t("message.nationality")}}<span class="text-danger">*</span></label>
              <div class="input-group mb-3">
                <!-- <label class="input-group-text" for="nationality2"
                >Nationality</label
              > -->
                <select
                  id="nationality"
                  v-model="form.nationality"
                  class="form-select"
                  :class="{ 'is-invalid': v$.form.nationality.$error }"
                  aria-label="Default select example"
                  @change="setdailcode"
                  searchable="Search here.."
                >
                  <option selected>Open this select menu</option>
                  <option
                    v-for="item in countryCode"
                    :key="item.id"
                    :value="item.id"
                    >{{ item.name }}</option
                  >
                </select>
                <!-- <input
                class="form-control"
                :class="{ 'is-invalid': v$.form.nationality.$error }"
                list="datalistOptions"
                id="nationality"
                v-model="form.nationality"
                placeholder="Type to search..."
                aria-label="Recipient's username"
                aria-describedby="nationality2"
              />
              <datalist id="datalistOptions">
                <option v-for="item in countryCode" :key="item.id"  :value="item.name"></option>
                <option value="New York"> </option>
                <option value="Seattle"> </option>
                <option value="Los Angeles"> </option>
                <option value="Chicago"> </option> -->
                <!-- </datalist> -->
              </div>
              <label for="lastname-firstname" class="form-label"
                >{{$t("message.nationality_idcard_or_passport")}}<span class="text-danger">*</span></label
              >
              <div class="input-group mb-3">
                <!-- <span class="input-group-text" id="idcard"
                >Khmer IDcard or Passport</span
              > -->
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.form.national_id_card.$error }"
                  v-model="form.national_id_card"
                  @input="updateForm"
                  aria-describedby="idcard"
                />
                <div class="invalid-feedback" v-if="errors?.national_id_card">
                    {{errors?.national_id_card[0]}}
                </div>
              </div>

              <label for="lastname-firstname" class="form-label"
                >{{$t("message.available_contact")}}<span class="text-danger">*</span></label
              >
              <div class="input-group mb-3">
                <!-- <span class="input-group-text" id="phone2">Phone</span> -->
                <input
                  type="text"
                  v-maska="'##########'"
                  v-model="form.phone"
                  @input="updateForm"
                  class="form-control"
                  :class="{ 'is-invalid': v$.form.phone.$error }"
                  id="basic-url"
                  aria-describedby="phone2"
                />
                <div class="invalid-feedback" v-if="errors?.phone">
                    {{errors?.phone[0]}}
                </div>
              </div>

              <label for="lastname-firstname" class="form-label">{{$t("message.email")}}<span class="text-danger">*</span></label>
              <div class="input-group mb-3">
                <!-- <span class="input-group-text" id="idcard">Email</span> -->
                <input
                  type="text"
                  v-model="form.email"
                  @input="updateForm"
                  :class="{ 'is-invalid': v$.form.email.$error }"
                  class="form-control"
                
                />
                <div class="invalid-feedback" v-if="errors?.email">
                    {{errors?.email[0]}}
                </div>
              </div>

              <label for="lastname-firstname" class="form-label"
                >{{$t("message.password")}}<span class="text-danger">*</span></label
              >
              <div class="input-group mb-3">
                <!-- <span class="input-group-text" id="idcard">Password</span> -->
                <input
                  type="password"
                  v-model="form.password"
                  @input="updateForm"
                  class="form-control"
                  :class="{ 'is-invalid': v$.form.password.$error }"
                  aria-describedby="idcard"
                />
              </div>
              <label for="lastname-firstname" class="form-label"
                >{{$t("message.confirm_password")}}<span class="text-danger">*</span></label
              >
              <div class="input-group mb-3">
                <!-- <span class="input-group-text" id="idcard">Conform Password</span> -->
                <input
                  type="password"
                  v-model="form.password_confirmation"
                  @input="updateForm"
                  class="form-control"
                  :class="{
                    'is-invalid': v$.form.password_confirmation.$error
                  }"
                  aria-describedby="idcard"
                />
              </div>
              <div class="saveNext">
                <button
                  type="button"
                  @click="saveConfirm"
                  class="btn btn-primary"
                >
                  {{$t("message.create_account")}}
                </button>

                <!-- <router-link class="btn btn-warning ms-2" :to="{ name: 'SystemLogin' }">
                  {{$t("message.login")}} <i class="fas fa-sign-in-alt"></i>
                </router-link>-->

              </div>
            </form>
          </div>
          <div class="card-body" v-if="showCodeInput">
            <form
              v-on:submit.prevent
              class="form-row justify-content-center"
              style="text-align: center;"
            >
              <label for="lastname-firstname" class="form-label"
                ><h4>
                  Email verification
                </h4>
                <p>Enter the confirmation code we just send on your email: {{form.email}}</p>
              </label
              >
              <div class="col-md-6 offset-md-3" style="text-align:center;">
                <div class="d-flex flex-row m-3">
                  <input
                  class="form-control-lg"
                  v-model="form.verification_code"
                  type="text"
                  style="text-align:center;width: 550px;
    margin: auto;"
                />
                  <!-- <input type="text" class="form-control text-center" autofocus="" v-model="code.one" @keyup="changeFocus(1)">
                  <input type="text" class="form-control ms-1 text-center" ref="input_2" v-model="code.two"  @keyup="changeFocus(2)">
                  <input type="text" class="form-control ms-1 text-center" ref="input_3" v-model="code.three"  @keyup="changeFocus(3)">
                  <input type="text" class="form-control ms-1 text-center" ref="input_4" v-model="code.foure"  @keyup="changeFocus(4)">
                  <input type="text" class="form-control ms-1 text-center" ref="input_5" v-model="code.five"  @keyup="changeFocus(5)">
                  <input type="text" class="form-control ms-1 text-center" ref="input_6" v-model="code.six" @keyup="signInWithVerificationCode"> -->
                </div>
                
                
                <button
                  type="button"
                  class="btn btn-primary"
                  style="margin-bottom: 20px; margin-right:15px;"
                  @click="signInWithVerificationCode"
                >
                   Verify
                </button>

              </div>
              <p class="text-black-50 text-center">Don't receive the code?</p>
              <button
                type="button"
                class="btn-default btn-sm"
                style="margin-top: 20px; margin-right:15px;"
                @click="goBack"
              >
                <i class="fas fa-arrow-left"></i> {{$t("message.back")}}
              </button>
              <button
                type="button"
                class="btn-warning btn-sm"
                style="margin-top: 20px; margin-right:15px;"
                @click="sendCodeSMS"
              >
                {{$t("message.resend")}} <i class="fas fa-redo-alt"></i>
              </button>
              <!-- <button
                type="button"
                class="btn-primary btn-sm"
                style="margin-top: 20px;"
                @click="signInWithVerificationCode"
              >
                Verify <i class="fas fa-paper-plane"></i>
              </button> -->
              <div style="height:200px;"></div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
import axios from "@/axios";
import useVuelidate from "@vuelidate/core";
import { required, requiredIf, email, sameAs } from "@vuelidate/validators";
import { mapGetters } from "vuex";
import { mapActions } from "vuex";

export default {
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      recaptcha: "",
      token: "",
      showNumberInput: true,
      showCodeInput: false,
      code: {one:'',two:'',three:'',foure:'',five:'',six:''},
      errors: []
    };
  },
  validations() {
    return {
      form: {
        participant_type: { required, $autoDirty: true },
        company_name: {
          requiredIf: requiredIf(() => {
            return this.form.participant_type == 2;
          }),
          $autoDirty: true
        },
        firstname: { required, $autoDirty: true },
        lastname: { required, $autoDirty: true },
        firstname_en: { required, $autoDirty: true },
        lastname_en: { required, $autoDirty: true },
        gender: { required, $autoDirty: true },
        dob: { required, $autoDirty: true },
        nationality: { required, $autoDirty: true },
        national_id_card: { required, $autoDirty: true },
        phone: { required, $autoDirty: true },
        email: { required, email, $autoDirty: true },
        password: { required, $autoDirty: true },
        password_confirmation: {
          required,
          sameAsPassword: sameAs(this.form.password),
          $autoDirty: true
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      // map `this.doneCount` to `this.$store.getters.doneTodosCount`
      form: "getSingUp",
      countryCode: "getCountryCode"
    })
  },
  methods: {
    ...mapActions(["act_loadCountryCode"]),
    updateForm() {
      this.$store.dispatch("act_changesingup", this.form);
    },
    setdailcode() {
      const dial_code = this.countryCode.filter(
        item => item.id == this.form.nationality
      )[0].dial_code;
      this.form.dial_code = dial_code;
      this.$store.dispatch("act_changesingup", this.form);
    },
    onCancelLoader() {
      console.log("User cancelled the loader.");
    },
    async sendCodeSMS() {
      let loader = this.showLoader();
      let response = await axios.post("request-opt-code", {
        email: this.form.email
      });
      if(response.data.status==200){
        this.showCodeInput = true;
        this.showNumberInput = false;
        this.form.verification_code = "";
        this.$store.dispatch("act_changesingup", this.form);
        loader.hide();
      }else{
          loader.hide();
          this.$toast.open({
            message: response.data.message,
            type: "error",
            duration: 5000,
            dismissible: true,
            position: "top-right"
          });
      }

      //console.log("it is send code email:",response);
      // const phoneNumber = this.form.dial_code + this.form.phone;
      // const appVerifier = window.recaptchaVerifier;
      // let loader = this.showLoader();
      // firebase
      //   .auth()
      //   .signInWithPhoneNumber(phoneNumber, appVerifier)
      //   .then(confirmationResult => {
      //     window.confirmationResult = confirmationResult;
      //     this.showCodeInput = true;
      //     this.showNumberInput = false;
      //     this.form.verification_code = "";
      //     this.$store.dispatch("act_changesingup", this.form);
      //     ///cancel loader
      //     loader.hide();
      //     // ...
      //   })
      //   .catch(error => {
      //     console.log("it is send fail", error);
      //     ///cancel loader
      //     loader.hide();
      //     //////open toaser
      //     this.$toast.open({
      //       message: "can not send code to your phone number! " + error.message,
      //       type: "error",
      //       duration: 5000,
      //       dismissible: true,
      //       position: "top-right"
      //     });
      //     //reset re
      //     this.resetRe();
      //   });
    },
    goBack() {
      this.showNumberInput = true;
      this.showCodeInput = false;
      this.resetRe();
    },
    showLoader() {
      return this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        color: "#01B201",
        canCancel: true,
        onCancel: this.onCancelLoader
      });
    },
    saveCreateForm() {
      let loader = this.showLoader();
      const res = this.$store.dispatch("act_signup", {
        form: this.form,
        router: this.$router
      });

      res
        .then(rs => {
          ///cancel loader
          loader.hide();
          console.log("after dispatch is success", rs);
          if (rs.status === 422) {
            console.log('it is :',rs.status);
            var m = rs.data.message;
            //if(rs.data.hasOwnProperty('errors')){
            if(Object.prototype.hasOwnProperty.call(rs.data,'errors')){
                const message = Object.values(rs.data.errors).join(",");
                m = m + message;
            }
            this.$toast.open({
              message: m,
              type: "error",
              duration: 5000,
              dismissible: true,
              position: "top-right"
            });

            //if(rs.data.hasOwnProperty('field')){
            if(Object.prototype.hasOwnProperty.call(rs.data,'field')){
              if(rs.data.field == 'phone'){
                this.form.phone = '';
              }else if(rs.data.field == 'national_id_card'){
                this.form.national_id_card = '';
              }
            }

            this.goBack();

          } else if (rs.status === 200) {
            this.$router.push({ name: "register" });
          }
          //
        })
        .catch(err => {
          ///cancel loader
          loader.hide();
          console.log("after dispatch is error", err);
        });
    },
    async saveConfirm() {
      this.v$.$validate(); // checks all inputs
      if (!this.v$.$error) {

        try {
          let response = await axios.post("check-data", this.form);
          if(!response.data.success){
              //if(response.data.error.hasOwnProperty('national_id_card')){
              if(Object.prototype.hasOwnProperty.call(response.data.errors,'national_id_card')){
                  this.form.national_id_card = '';
              }
              //if(response.data.error.hasOwnProperty('phone')){
              if(Object.prototype.hasOwnProperty.call(response.data.errors,'phone')){
                  this.form.phone = '';
              }
              //if(response.data.error.hasOwnProperty('email')){
              if(Object.prototype.hasOwnProperty.call(response.data.errors,'email')){
                  this.form.email = '';
              }
              this.$toast.open({
                message: "data already exist! : " + Object.keys(response.data.errors).join(', '),
                type: "error",
                duration: 5000,
                dismissible: true,
                position: "top-right"
              });
          }else{
            //send code sms to phone number
            this.sendCodeSMS();
          }
        } catch (error) {
          this.errors = {...error.response.data.errors};
          console.log(error.response.data.errors);
          console.log('data errors:',this.errors);
          let a = {};
          for (const [key] of Object.entries(error.response.data.errors)) {
            a[key] = '';
          }
        
          Object.assign(this.form, a);
          this.$toast.open({
                message: "data already exist! : " + Object.keys(error.response.data.errors).join(', '),
                type: "error",
                duration: 5000,
                dismissible: true,
                position: "top-right"
              });
        }
        
      } else {
        this.$toast.open({
          message: "Form is invalid",
          type: "error",
          duration: 5000,
          dismissible: true,
          position: "top-right"
        });
      }
    },
    async signInWithVerificationCode() {

      // console.log("it is comfrimation code",{
      //  email: this.form.email,
      //    otp: this.form.verification_code
      //  });

      let response = await axios.post("verify-opt-code", {
        email: this.form.email,
        otp: this.form.verification_code
      });
      if(response.data.status==200){
        this.saveCreateForm();
      }else{
         this.$toast.open({
            message: response.data.message,
            type: "error",
            duration: 5000,
            dismissible: true,
            position: "top-right"
          });
      }

      // if(this.code.one && this.code.two && this.code.three && this.code.foure && this.code.five && this.code.six){
      //   this.form.verification_code = this.code.one.toString() + this.code.two.toString() + this.code.three.toString() + this.code.foure.toString() + this.code.five.toString() + this.code.six.toString();  
      //   const code = this.form.verification_code;
      //   window.confirmationResult
      //     .confirm(code)
      //     .then(result => {
      //       // User signed in successfully.
      //       const user = result.user;
      //       console.log("This is user Auth:", user);
      //       this.saveCreateForm();
      //       this.code = {one:'',two:'',three:'',foure:'',five:'',six:''};
      //     })
      //     .catch(error => {
      //       console.log(error);
      //       this.code = {one:'',two:'',three:'',foure:'',five:'',six:''};
      //       // User couldn't sign in (bad verification code?)
      //       // ...
      //     });
      //   this.code = {one:'',two:'',three:'',foure:'',five:'',six:''};
      // }      
    },
    changeFocus(id){
      const v =id+1;
      this.$refs["input_" + v].focus();
    },
    initailAuth() {
      firebase.auth().languageCode = "km";
      // Start Firebase invisible reCAPTCHA verifier
      window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
        "get-sign-in-code",
        {
          size: "invisible",
          callback: response => {
            console.log("response recapcha", response);
            // reCAPTCHA solved, allow signInWithPhoneNumber.
            console.log("it is run");
          }
        }
      );

      window.recaptchaVerifier.render().then(widgetId => {
        window.recaptchaWidgetId = widgetId;
      });
    },
    async getCamDigikey() {
      let loader = this.showLoader();
      try {
          let response = await axios.post("get-camdigikey");
          if (response.data.status) {
            loader.hide();
            window.location.href = response.data.response.loginUrl;
          } else {
            loader.hide();
            this.$toast.open({
              message: "Login fail " + response.message,
              type: "error",
              duration: 5000,
              dismissible: true,
              position: "top-right"
            });
          }
        //console.log("it is respone:", response);
      } catch (error) {
        loader.hide();
        //console.log("it is error:", error);
      }
    }
  },
  created() {},
  mounted() {
    this.initailAuth();
    this.act_loadCountryCode();
  }
};
</script>
<style scoped>
.margin-top {
  margin-top: 50px;
  background-color: rgb(238, 238, 238);
}
</style>
